import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, adminOnly }) {
  const { user, loading, openAuthGate } = useAuth();
  const location = useLocation();
  // Demo tour for guests — allows access to specific feature pages in read-only mode.
  const isDemo = new URLSearchParams(location.search).get("demo") === "1";

  useEffect(() => {
    if (!loading && !user && !isDemo) {
      openAuthGate();
    }
  }, [loading, user, openAuthGate, isDemo]);

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)" }} data-testid="splash-loader">
        <div style={{ width: 40, height: 40, border: "3px solid #27272A", borderTopColor: "var(--primary)", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!user) {
    // Demo mode: let guests through; the page itself handles read-only behaviour.
    if (isDemo) return children;
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  if (adminOnly && !["admin", "reviewer"].includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
